import React, { FC } from 'react';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
    },
  });

const Separator: FC<WithStyles<typeof styles>> = ({ classes }) => (
  <span className={classes.root}>-</span>
);

export default withStyles(styles)(Separator);
